export default __webpack_public_path__ + "static/092-2e4f114d8caa82a886776cb92b7a7bc7.jpg";